import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@kollektive/design-system';

// Design system CSS (includes tokens and component styles)
import '@kollektive/design-system/dist/index.css';
// Tenant portal specific styles
import './index.css';

import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider defaultTheme="dark">
      <App />
    </ThemeProvider>
  </StrictMode>
);
